import { useEffect, useState } from "react";

export default function SaveTheDateForm({
  allowPlusOne = false,
  onSubmit,
  submitLabel,
  isSubmitting = false,
  errorMessage = null,
  successMessage = null,
}) {
  const [plusOne, setPlusOne] = useState(false);

  useEffect(() => {
    if (!allowPlusOne) {
      setPlusOne(false);
    }
  }, [allowPlusOne]);

  return (
    <form
      className="save-the-date-form"
      onSubmit={onSubmit}
      aria-busy={isSubmitting}
      data-submitting={isSubmitting ? "true" : undefined}
    >
      {successMessage ? (
        <p className="save-the-date-form-message save-the-date-form-message--success" role="status">
          {successMessage}
        </p>
      ) : null}
      {errorMessage ? (
        <p className="save-the-date-form-message save-the-date-form-message--error" role="alert">
          {errorMessage}
        </p>
      ) : null}

      <fieldset className="save-the-date-form-fieldset" disabled={isSubmitting}>
        <legend className="visually-hidden">Your response</legend>

        <p className="save-the-date-form-section-label">Your details</p>

        <label htmlFor="name">Your full name</label>
        <input
          id="name"
          name="name"
          type="text"
          required
          placeholder="Alex Smith"
          autoComplete="name"
        />

        <label htmlFor="email">Your email address</label>
        <input
          id="email"
          name="email"
          type="email"
          required
          placeholder="alex@email.com"
          autoComplete="email"
        />

        {allowPlusOne ? (
          <>
            <label className="save-the-date-form-checkbox">
              <input
                type="checkbox"
                name="plusOne"
                value="true"
                checked={plusOne}
                onChange={(e) => setPlusOne(e.target.checked)}
              />
              <span>2nd person / guest</span>
            </label>

            {plusOne ? (
              <div className="save-the-date-form-plus-one">
                <p className="save-the-date-form-section-label">2nd person / guest</p>
                <label htmlFor="plusOneName">Full name</label>
                <input
                  id="plusOneName"
                  name="plusOneName"
                  type="text"
                  required
                  placeholder="Jordan Lee"
                  autoComplete="off"
                />

                <label htmlFor="plusOneEmail">Email address</label>
                <input
                  id="plusOneEmail"
                  name="plusOneEmail"
                  type="email"
                  required
                  placeholder="jordan@email.com"
                  autoComplete="email"
                />
              </div>
            ) : null}
          </>
        ) : null}

        <button type="submit">{isSubmitting ? "Sending…" : submitLabel}</button>
      </fieldset>

      {isSubmitting ? (
        <p className="form-status-text" role="status" aria-live="polite">
          Sending your details — please keep this page open.
        </p>
      ) : null}
    </form>
  );
}
